import { Shell } from "@/components/layout/Shell";
import { useSeo } from "@/hooks/use-seo";

export default function Privacy() {
  useSeo({
    title: "Privacy Policy | Mychromamind",
    description:
      "How Mychromamind handles data, cookies, and third-party advertising on this site.",
    path: "/privacy",
  });

  return (
    <Shell>
      <div className="max-w-3xl mx-auto px-6 py-12 md:py-24 w-full prose prose-neutral dark:prose-invert">
        <h1 className="font-serif">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground">Last updated: July 8, 2026</p>

        <p>
          Mychromamind ("we", "the site") is a color-psychology entertainment and self-reflection
          site. This page explains what information is collected when you use it.
        </p>

        <h2>Quiz responses</h2>
        <p>
          Your color choices during the personality and decision quizzes are processed in your
          browser to generate a result. We do not require an account, and quiz answers are not
          stored on a server or linked to your identity.
        </p>

        <h2>Cookies and similar technologies</h2>
        <p>
          This site may use cookies and similar technologies for basic functionality and, where
          enabled, to serve advertising. Advertising partners (such as Google) may use cookies or
          device identifiers to show ads based on your visits to this and other sites.
        </p>

        <h2>Third-party advertising</h2>
        <p>
          We may display ads served by third-party advertising companies, including Google. These
          companies may use information about your visits to this and other websites to provide
          advertisements about goods and services of interest to you. You can learn more about how
          Google uses data and opt out of personalized advertising by visiting Google's{" "}
          <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">
            Ads Policy page
          </a>{" "}
          and{" "}
          <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">
            Ad Settings
          </a>
          .
        </p>

        <h2>Social sharing</h2>
        <p>
          Share buttons on quiz results and color pages link directly to each platform's own share
          page (for example X, Facebook, LinkedIn, or WhatsApp) or use your device's native share
          sheet. We do not embed any third-party sharing scripts or widgets, so no additional
          tracking script runs unless you click a share button — at which point you leave this site
          and that platform's own privacy policy applies. The "copy link" option simply copies the
          page URL to your clipboard and does not involve any third party.
        </p>

        <h2>Analytics</h2>
        <p>
          We may use aggregated, anonymous analytics to understand how the site is used, in order
          to improve it. This data is not used to identify individual visitors.
        </p>

        <h2>Contact</h2>
        <p>
          If you have questions about this policy, please reach out through the contact details
          provided wherever this site is published.
        </p>
      </div>
    </Shell>
  );
}
